// extracted by mini-css-extract-plugin
export default {"zoomModal":"F1-z"};